import {ref} from "vue";
import {defineStore} from "pinia";
import {useCareerCoach} from "./career-coach.store";
import {openLink, isOneWeekPassedFrom} from "../utils/helpers";
import {setAuthState} from "../composables/auth";
import {update} from "../api/profile";
import {SHOPIFY_THEME} from "../storage";


const FEATURES = {
    resumeAi: 'resum_ai',
    autoApply: 'auto_apply'
}

const FEATURE_NUDGE_MAP = {
    [FEATURES.resumeAi]: {
        utmLink: 'https://bit.ly/4aDSMZH',
        dbFieldName: 'resume_ai_nudged_at'
    },
    [FEATURES.autoApply]: {
        utmLink: 'https://bit.ly/4dTFBXx',
        dbFieldName: 'auto_apply_nudged_at'
    }
}

const {getUser, setUser} = setAuthState();

export const useServicesNudges = defineStore("services-nudges", () => {
    const showModal = ref(false);
    const selectedFeature = ref(null);
    const client = ref(null)
    const ui = ref(null)
    const careerCoachStore = useCareerCoach();

    const updateNudgedAtFor = (feature) => {
        update({
            options: {
                ...getUser()?.options,
                [feature]: new Date()
            }
        }).then(response => {
            setUser(response.data.data);
        })
    }

    const showNudgeModalFor = async (feature) => {
        const featureFieldName = FEATURE_NUDGE_MAP[feature]?.dbFieldName

        if (getUser()?.options?.[featureFieldName] == null || isOneWeekPassedFrom(getUser()?.options?.[featureFieldName])) {
            selectedFeature.value = feature;
            showModal.value = true;
            updateNudgedAtFor(featureFieldName)
        }
    }


    const ShopifyBuyInit = () => {
        client.value = ShopifyBuy.buildClient({
            domain: 'wonsulting.myshopify.com',
            storefrontAccessToken: '58c36d890bddc3cb0c484b7a7d10e1fb',
        });

        ui.value = ShopifyBuy.UI.init(client.value);
    }

    const generateShopifyBuyButton = (computedTiers, individualServices) => {
        ShopifyBuy.UI.onReady(client.value).then((ui) => {
            computedTiers.forEach((tier) => {
                ui.createComponent('product', {
                    id: tier.price.productId,
                    node: document.getElementById(tier.componentId),
                    moneyFormat: '%24%7B%7Bamount%7D%7D',
                    options: SHOPIFY_THEME,
                });
            })

            individualServices.forEach((individualService) => {
                ui.createComponent('product', {
                    id: individualService.productId,
                    node: document.getElementById(individualService.componentId),
                    moneyFormat: '%24%7B%7Bamount%7D%7D',
                    options: SHOPIFY_THEME,
                });
            })
        });

    }

    const nudgeCtaClickHandler = (feature) => {
        openLink(FEATURE_NUDGE_MAP[feature].utmLink, true);
    }

    const closeModal = () => {
        showModal.value = false;
    }

    return {
        showNudgeModalFor,
        closeModal,
        nudgeCtaClickHandler,
        ShopifyBuyInit,
        generateShopifyBuyButton,

        selectedFeature,
        showModal,
        FEATURES
    };
});
